import { render, staticRenderFns } from "./dropdown-list.vue?vue&type=template&id=b44d8fbe&scoped=true"
import script from "./dropdown-list.vue?vue&type=script&lang=js"
export * from "./dropdown-list.vue?vue&type=script&lang=js"
import style0 from "./dropdown-list.vue?vue&type=style&index=0&id=b44d8fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44d8fbe",
  null
  
)

export default component.exports